import dynamic from 'next/dynamic';

export const DynamicFilterSettingsMobilePopovers = dynamic(
  () =>
    import(
      /* webpackChunkName: 'FilterSettingsMobilePopovers.client' */ './FilterSettingsMobilePopovers.client'
    ),
  {
    ssr: false,
  },
);
